import React from 'react';

/**
 * Blocks any keystroke that would make the field anything other than a
 * non-negative integer (0 allowed). Returns true when the key should be
 * prevented. Digits, Backspace/Delete, and navigation keys are allowed;
 * decimal points and minus signs are rejected.
 */
export const validateNonNegativeIntegerField = (
    event: React.KeyboardEvent<HTMLInputElement>
): boolean => {
    if (
        !/[0-9]/.test(event.key) &&
        event.key !== 'Backspace' &&
        event.key !== 'Delete' &&
        event.key !== 'ArrowRight' &&
        event.key !== 'ArrowLeft' &&
        event.key !== 'Tab'
    ) {
        return true;
    }

    return false;
};

export const validatePercentageField = (
    event: React.KeyboardEvent<HTMLInputElement>,
    currentValue: string,
    maxDecimals = 3
): boolean => {
    const normalizedValue = currentValue.replace('%', '');
    const decimalLength = (value: string) =>
        value.includes('.') ? (value.split('.').pop()?.length ?? 0) : 0;
    const selectionStart = event.currentTarget.selectionStart ?? 0;
    const isChangeAfterDot = selectionStart > normalizedValue.length - 2;
    const isMaxDecimalsReached = decimalLength(normalizedValue) >= maxDecimals;

    if (
        !/[0-9]/.test(event.key) &&
        event.key !== 'Backspace' &&
        event.key !== 'ArrowRight' &&
        event.key !== 'ArrowLeft' &&
        event.key !== 'Tab' &&
        (event.key !== '.' || normalizedValue.includes('.'))
    ) {
        return true;
    }

    if (event.key === '.' && !isChangeAfterDot) {
        return true;
    }

    if (/[0-9]/.test(event.key) && isMaxDecimalsReached && isChangeAfterDot) {
        return true;
    }

    return false;
};
